<div class="row text-center">
  <div class="col-12">
    <component-tabs
            [serviceId]="serviceId"
            [componentKey]="componentKey"
            [componentTabId]="componentTabId"
            [determinantMapById]="determinantMapById"
            (changed)="sendNrOfTabs($event)">
    </component-tabs>
  </div>
</div>
